<template>
  <div class="identity">
    <div v-if="isUserLoggedIn" class="identity__loggedin">
      <Dropdown :items="items" :logoutUser="logoutUser" :UserLogged="currentUser" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import netlifyIdentity from 'netlify-identity-widget';
import Dropdown from '@/components/UI/Dropdown.vue';

export default {
  name: 'Identity',
  props: {
    items: Array,
  },
  components: {
    Dropdown,
  },
  created() {
    netlifyIdentity.init();
    this.setCurrentUser(netlifyIdentity.currentUser());

    netlifyIdentity.on('close', () => {
      console.log('Executing netlifyIdentity close hook.');
      this.setCurrentUser(null);
      this.$router.push({ path: '/' });
    });

    netlifyIdentity.on('login', (user) => {
      console.log('Executing netlifyIdentity login hook.');
      this.setCurrentUser(user);
    });

    netlifyIdentity.on('logout', () => {
      console.log('Executing netlifyIdentity logout hook.');
      this.setCurrentUser(null);
      netlifyIdentity.close();
    });
  },
  methods: {
    ...mapMutations({
      clearLinks: 'UrlInput/clearLinks',
      setCurrentUser: 'setCurrentUser',
    }),
    logoutUser(e) {
      e.preventDefault();
      this.clearLinks();
      netlifyIdentity.logout();
    },
  },
  computed: {
    ...mapGetters([
      'isUserLoggedIn',
    ]),
    currentUser() {
      return netlifyIdentity.currentUser();
    },
  },
};
</script>
